export const accessControlBadgeFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
    label: 'global.access_control_badge.id.label',
    inputType: 'input',
    options: [],
    id: 'global-access-control-badge__id',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'global.access_control_badge.code.label',
    inputType: 'input',
    options: [],
    id: 'global-access-control-badge__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.access_control_badge.status.label',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.cancelled.label',
        value: 'cancelled',
      },
      {
        text: 'global.fields.status.blocked.label',
        value: 'blocked',
      },
    ],
    id: 'global-access-control-badge__status',
    veeValidation: true,
    rules: [],
    warningRules: [],
    defaultValue: 'active',
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'cancelled',
        color: 'border-0 text-white bg-danger',
      },
      {
        value: 'blocked',
        color: 'border-0 text-white bg-warning',
      },
    ],
  },
  type: {
    fieldPath: 'type',
    fieldReadPath: 'type',
    name: 'type',
    label: 'global.access_control_badge.type.label',
    inputType: 'select',
    defaultValue: 'rfid',
    options: [
      {
        text: 'access_control.access_control_badges.type.rfid.label',
        value: 'rfid',
      },
      {
        text: 'access_control.access_control_badges.type.bar_code.label',
        value: 'bar_code',
      },
    ],
    id: 'global-access-control-badge__type',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'global.access_control_badge.contact.label',
    options: [],
    id: 'selects-access-control-badge__contact-id',
    rules: [],
    selectLabel: 'fullname',
    selectEntity: 'contact',
    selectMultiple: false,
    selectValue: 'id',
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: ['individual'],
      },
    ],
  },
  contact: {
    fieldPath: 'contact',
    fieldReadPath: 'contact',
    name: 'contact',
    label: 'global.access_control_badge.contact.label',
    options: [],
    id: 'selects-access-control-badge__contact-id',
    rules: [],
    selectLabel: 'fullname',
    selectEntity: 'contact',
    selectMultiple: false,
    selectValue: 'id',
  },
  subscriptions: {
    fieldPath: 'subscriptions',
    fieldReadPath: 'subscriptions',
    name: 'subscriptions',
    label: 'global.access_control_badge.subscription.label',
    options: [],
    id: 'selects-access-control-badge__subscriptions',
    rules: [],
    selectLabel: 'code_name',
    selectEntity: 'subscription',
    selectMultiple: false,
    selectValue: 'id',
  },
  BCEntries: {
    fieldPath: 'BCEntries',
    fieldReadPath: 'BCEntries',
    name: 'BCEntries',
    label: 'global.access_control_badge.entry.label',
    options: [],
    id: 'selects-access-control-badge__entries',
    rules: [],
    selectLabel: 'id',
    selectEntity: 'entry',
    selectMultiple: false,
    selectValue: 'id',
  },
  attendees: {
    fieldPath: 'attendees',
    fieldReadPath: 'attendees',
    name: 'attendees',
    label: 'global.access_control_badge.attendee.label',
    options: [],
    id: 'selects-access-control-badge__attendees',
    rules: [],
    selectLabel: 'code',
    selectEntity: 'attendee',
    selectMultiple: false,
    selectValue: 'id',
  },
  enrollments: {
    fieldPath: 'enrollments',
    fieldReadPath: 'enrollments',
    name: 'enrollments',
    label: 'global.access_control_badge.attendee.label',
    options: [],
    id: 'selects-access-control-badge__enrollments',
    rules: [],
    selectLabel: 'code',
    selectEntity: 'enrollment',
    selectMultiple: false,
    selectValue: 'id',
  },
  subscriptionsTable: {
    inputType: 'entity-select-table',
    selectLabel: 'code',
    selectEntity: 'subscription',
    displayConfigName: 'table-input',
    tableDisplayConfigName: 'table-input',
    formConfigName: 'default',
    // selectConfigName: 'default',
    filterConfigName: 'select-table',
    selectMultiple: true,
    withTableSearch: true,
    withNew: true,
    withInfo: false,
    placeholder: 'global.table.filter.search_and_add',
    withDelete: false,
    withRemove: true,
  },
  subscription: {
    fieldPath: 'subscription',
    fieldReadPath: 'subscription',
    name: 'subscription',
    label: 'global.access_control_badge.subscription.label',
    options: [],
    id: 'selects-access-control-badge__subscription-id',
    rules: [],
    selectLabel: 'code',
    selectEntity: 'subscription',
    selectMultiple: false,
    selectValue: 'id',
  },
  badge_number: {
    fieldPath: 'badge_number',
    fieldReadPath: 'badge_number',
    name: 'badge_number',
    label: 'global.access_control_badge.badge_number.label',
    inputType: 'input',
    options: [],
    id: 'global-access_control_badge__badge_number',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  primary: {
    fieldPath: 'primary',
    fieldReadPath: 'primary',
    name: 'primary',
    label: 'global.access_control_badge.primary.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  external_id: {
    fieldPath: 'external_id',
    fieldReadPath: 'external_id',
    name: 'external_id',
    label: 'global.access_control_badge.external_id.label',
    inputType: 'input',
    options: [],
    id: 'global-access-control-badge__external-id',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  blocking_reason: {
    fieldPath: 'blocking_reason',
    fieldReadPath: 'blocking_reason',
    name: 'blocking_reason',
    label: 'global.access_control_badge.blocking_reason.label',
    inputType: 'input',
    options: [],
    id: 'global-access-control-badge__blocking-reason',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
};
export const accessControlBadgeFilters = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'global.access_control_badge.status.label',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.cancelled.label',
        value: 'cancelled',
      },
      {
        text: 'global.fields.status.blocked.label',
        value: 'blocked',
      },
      {
        text: 'global.fields.status.trash.label',
        value: 'trash',
      },
    ],
    id: 'global-filter-access-control-badge__status',
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'global.access_control_badge.contact.label',
    inputType: 'entity-select',
    options: [],
    id: 'selects-filter-access-control-badge__contact-id',
  },
  subscription_id: {
    fieldPath: 'subscription_id',
    fieldReadPath: 'subscription_id',
    name: 'subscription_id',
    label: 'global.access_control_badge.subscription.label',
    inputType: 'entity-select',
    options: [],
    id: 'selects-filter-access-control-badge__subscription-id',
  },
};

export const accessControlBadgeDisplayFields = {
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'active', label: 'global.fields.status.active.label' },
      { value: 'cancelled', label: 'global.fields.status.cancelled.label' },
      { value: 'blocked', label: 'global.fields.status.blocked.label' },
    ],
    valueToVariant: [
      { value: 'active', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
      { value: 'blocked', variant: 'warning' },
    ],
  },
  primary: {
    displayType: 'badge',
    valueToLabel: [
      { value: true, label: 'global.yes' },
      { value: false, label: 'global.no' },
    ],
    valueToVariant: [
      { value: true, variant: 'success' },
      { value: false, variant: 'light' },
    ],
  },
  contact: {
    displayType: 'contact-link',
    useDrawer: true,
    formConfigName: 'edit',
    drawerSize: 'lg',
    configFileName: 'contact',
  },
};

export const accessControlSaleFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
    label: 'access_control.access_control_sale.id.label',
    inputType: 'input',
    options: [],
    id: 'access-control-access-control-sale__id',
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  centerId: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
    label: 'access_control.access_control_sale.center_id.label',
    inputType: 'input',
    options: [],
    id: 'access-control-access-control-sale__center-id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
  },
  saleId: {
    fieldPath: 'saleId',
    fieldReadPath: 'saleId',
    name: 'saleId',
    label: 'access_control.access_control_sale.sale_id.label',
    inputType: 'input',
    options: [],
    id: 'access-control-access-control-sale__sale-id',
    veeValidation: false,
    rules: [],
    warningRules: [],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'access_control.access_control_sale.status.label',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.synchronized.label',
        value: 'synchronized',
      },
      {
        text: 'global.fields.status.error.label',
        value: 'error',
      },
    ],
    id: 'access-control-access-control-sale__status',
    veeValidation: true,
    rules: ['required', 'in:synchronized,error'],
    warningRules: [],
    defaultValue: 'synchronized',
    valueToColor: [
      {
        value: 'synchronized',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'error',
        color: 'border-0 text-white bg-danger',
      },
    ],
  },
  lastSyncAt: {
    fieldPath: 'lastSyncAt',
    errorFieldPath: 'lastSyncAt',
    fieldReadPath: 'lastSyncAt',
    name: 'lastSyncAt',
    id: 'access-control-access-control-sale__lastSyncAt',
    veeValidation: true,
    rules: ['nullable', 'date', 'date_format:Y-m-d H:i'],
    label: 'access_control.access_control_sale.last_sync_at.label',
  },
  syncError: {
    fieldPath: 'syncError',
    errorFieldPath: 'syncError',
    fieldReadPath: 'syncError',
    name: 'syncError',
    id: 'access-control-access-control-sale__syncError',
    veeValidation: true,
    rules: ['nullable', 'string'],
    label: 'access_control.access_control_sale.sync_error.label',
  },
};

export const accessControlSaleDisplayFields = {
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'synchronized', label: 'global.fields.status.synchronized.label' },
      { value: 'error', label: 'global.status.error' },
    ],
    valueToVariant: [
      { value: 'synchronized', variant: 'success' },
      { value: 'error', variant: 'danger' },
    ],
  },
};

export const accessControlProductDisplayConfig = {
  productFieldsToShowInTable: [
    {
      key: 'code',
      headerLabel: 'global.access_control_badge.code.header_label',
    },
    {
      key: 'status',
      headerLabel: `global.status.label`,
    },
    {
      key: 'description',
      headerLabel: `global.description.label`,
    },
  ],
  subscriptionStatusDisplayConfig: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'requested', label: 'global.subscription.requested' },
      {
        value: 'requested_not_blocked',
        label: 'global.subscription.requested_not_blocked',
      },
      { value: 'ongoing', label: 'global.subscription.ongoing' },
      { value: 'finished', label: 'global.subscription.finished' },
      { value: 'cancelled', label: 'global.subscription.cancelled' },
    ],
    valueToVariant: [
      { value: 'ongoing', variant: 'success' },
      { value: 'finished', variant: 'light' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },
  enrollmentStatusDisplayConfig: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'approved', label: 'global.status.approved' },
      { value: 'waiting', label: 'global.status.waiting' },
      { value: 'waiting_not_blocked', label: 'global.status.waiting_not_blocked' },
      { value: 'cancelled', label: 'global.status.cancelled' },
      { value: 'queued', label: 'global.status.queued' },
    ],
    valueToVariant: [
      { value: 'ongoing', variant: 'primary' },
      { value: 'confirmed', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },
  entryStatusDisplayConfig: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'requested', label: 'global.status.requested' },
      { value: 'confirmed', label: 'global.status.confirmed' },
      { value: 'cancelled', label: 'global.status.cancelled' },
    ],
    valueToVariant: [
      { value: 'ongoing', variant: 'primary' },
      { value: 'confirmed', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },
  productTypeDisplayConfig: {
    valueToLabel: [
      { value: 'subscription', label: 'global.access_control_badge_type_subscription_label' },
      { value: 'attendee', label: 'global.access_control_badge_type_attendee_label' },
    ],
  },
  attendeeStatusDisplayConfig: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'active', label: 'global.fields.status.active.label' },
      {
        value: 'cancelled',
        label: 'global.fields.status.cancelled.label',
      },
    ],
    valueToVariant: [
      { value: 'active', variant: 'success' },
      { value: 'cancelled', variant: 'danger' },
    ],
  },
};
